const textFieldLogin1 = {
  email: 'Email',
  password: 'Password'
};

export default textFieldLogin1;
